import TopbarActionButtons from './TopbarActionButtons.jsx';
import TopbarRightMenu from './TopbarRightMenu.jsx';
import TopbarSearch from './TopbarSearch.jsx';
import {
  topbarDividerClass,
  topbarRightActionsClass,
  topbarRightGroupAClass,
  topbarRightGroupBClass,
  topbarRightZoneClass,
} from './topbarClasses.js';

const TopbarRightZone = ({
  searchProps = {},
  onOpenSearch,
  actionButtons = [],
  topbarVariant = 'default',
  actionTooltips = {},
  company,
  accountMenu = {},
  labels = {},
  tooltips = {},
  studio,
  selectedApplication,
}) => (
  <div className={topbarRightZoneClass}>
    <div className={topbarRightGroupAClass}>
      <div className={topbarRightActionsClass}>
        {(onOpenSearch || searchProps?.onOpen) && (
          <TopbarSearch variant="icon" searchProps={searchProps} onOpenSearch={onOpenSearch} />
        )}
        <TopbarActionButtons
          actions={actionButtons}
          topbarVariant={topbarVariant}
          tooltips={actionTooltips}
        />
      </div>
    </div>
    <div className={topbarDividerClass} aria-hidden />
    <div className={topbarRightGroupBClass}>
      <TopbarRightMenu
        company={company}
        accountMenu={accountMenu}
        labels={labels}
        tooltips={tooltips}
        studio={studio}
        selectedApplication={selectedApplication}
        className="inline-flex w-fit max-w-full overflow-visible"
      />
    </div>
  </div>
);

export default TopbarRightZone;
